<div class="w-100 d-flex flex-column min-vh-100">
  <!-- Navbar Section -->
  <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
    <div class="container-fluid">
      <div class="row w-100 align-items-start gx-3">
        <!-- Logo Column -->
        <div class="col-md-3 col-lg-2 d-flex justify-content-center align-items-center pt-4">
          <a
            class="navbar-brand"
            href="#"
            (click)="handleLogoClick()"
          >
            <img 
              src="/api/swirl/sapi/branding/?target=light"
              alt="SWIRL logo" 
              class="logo-img"
            />
          </a>
        </div>
  
        <!-- Combined Search Box + Icons Column -->
        <div class="col-md-9 col-lg-10 pt-4 d-flex align-items-start navbar-main">
          <div class="flex-grow-1 me-3 navbar-searchwrap">
            <app-box [promptsExists]="promptsExists"></app-box>
          </div>

          <div class="d-flex align-items-center navbar-icons">
            <info-menu class="me-2"></info-menu>
            <profile-box></profile-box>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <!-- PDF export header (only) -->
  <div class="print-header" aria-hidden="true">
    <img class="print-logo" src="/api/swirl/sapi/branding/?target=chat" alt="SWIRL logo" />

    <div class="print-context">
      <span class="print-label">Query: </span>
      <span class="print-value">{{ lastQuery || '—' }}</span>
    </div>
  </div>

  <!-- Main Content Section -->
  <div class="container-fluid px-3 flex-grow-1 mt-3">
    <!-- Chart Section - user option -->
    <div *ngIf="isEnabledCharts && !isLoading" class="mb-3">
      <charts-container></charts-container>
    </div>

    <!-- Results Section -->
    <div class="row align-items-start">
      <!-- Sources Column -->
      <div class="col-md-3 col-lg-2 sources-column me-3" *ngIf="hasFacets">
        <app-facet-nav></app-facet-nav>
      </div>
  
      <!-- Results Column -->
      <div class="col-md-8 col-lg-9 results-column ms-3 p-0">
        <div class="row gx-0">
          <app-results
            [canExportPdf]="canExportPdf"
            (exportPdf)="onExportPdf()">
          </app-results>
        </div>
      </div>
  
      <!-- Right Spacer Column -->
      <div class="d-none d-lg-block col-auto ms-auto">
        <!-- Empty for spacing -->
      </div>
    </div>
  </div>
</div>
